import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ROUTES } from "./routerConfig";
import ViewSummary from "../pages/summary/ViewSummary";
import ViewBulkDocumentsView from "../pages/summary/ViewBulkDocumentsView";
import MandatoryDocumentsView from "../pages/summary/MandatoryDocumentsView";
import ViewCustomerUploadDocumentsView from "../pages/summary/ViewCustomerUploadDocumentsView";
import DashboardLayoutJourny from "../components/layouts/DashboardLayoutJourny";
import NotFound from "../pages/other/NotFound";
import NotFoundLayout from "../components/layouts/NotFoundLayout";
import { RootState } from "../services/redux/store";
import { useEffect } from "react";

const Router = () => {
  const partnerStartedJourney = useSelector(
    (state: RootState) => state.stepper.partnerStartedJourney
  );
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location?.pathname?.includes("customer-upload-documents") && !partnerStartedJourney) {
      navigate(ROUTES.Base.notFound);
    }
  }, [partnerStartedJourney, location]);

  return (
    <Routes>
      <Route path={ROUTES.Application.index} element={<DashboardLayoutJourny />} >
        <Route
          path={ROUTES.Application.index}
          element={<ViewSummary />}
        />
        <Route
          path={`${ROUTES.Application.mandatoryDocuments.path}`}
          element={<MandatoryDocumentsView />}
        />
        <Route
          path={`${ROUTES?.Application?.bulkDocuments?.path}`}
          element={<ViewBulkDocumentsView />}
        />
        {partnerStartedJourney && (
          <Route
            path={`${ROUTES?.Application?.customerUploadDocuments?.path}`}
            element={<ViewCustomerUploadDocumentsView />}
          />
        )}
      </Route>

      <Route path={ROUTES.Base.notFound} element={<NotFoundLayout />}>
        <Route index element={<NotFound />} />
      </Route>

    </Routes>
  );
};

export default Router;
